import * as d3 from 'd3';
export var createYScale = function createYScale(domain, height) {
  return d3.scaleLinear().domain(domain).range([height, 0]);
};
export var createXScale = function createXScale(domain, width) {
  return d3.scaleLinear().domain(domain).range([0, width]);
};